import React from "react";

function CarCard({ car }) {
  return (
    <div className="car-card h-100 shadow-sm margin-left margin-right">

      <img src={car.image} alt={car.name} />

      <div className="p-3 text-center">

        <h3 className="mb-2">{car.name}</h3>

        <p className="text-muted">{car.price}</p>

        <button className="btn btn-danger w-100">
          View Details
        </button>

      </div>

    </div>
  );
}

export default CarCard;